import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        await this.GetAllBranches();

        if (this.loginDetails) {
            if (this.loginDetails.userType != 1)
                this.logout();
        }

        if (this.isAddPage) {
            this.ClearForm(this.ruleForm);
        } else {
            this.GetInfo();
            this.GetSpecStatistics();
        }
    },

    watch: {
        '$route'(to) {
            if (!to) return;
            if (to.name === 'UsersAdd') {
                this.state = 0;
                this.ClearForm(this.ruleForm);
            } else if (to.name === 'Users' && this.state === 0) {
                this.GetInfo();
            }
        },
    },

    computed: {
        isAddPage() {
            return (this.$route && this.$route.name) === 'UsersAdd';
        },

        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },

        totalPagesT() {
            return Math.ceil(this.pagesT / this.pageSizeT);
        },

        userTypeOptionsForModal() {
            const raw = this.ruleForm.UserType;
            if (raw === '' || raw === null || raw === undefined) {
                return this.adminMinistryUserTypeOptions;
            }
            const id = Number(raw);
            if (!id || this.adminMinistryUserTypeOptions.some(o => o.id === id)) {
                return this.adminMinistryUserTypeOptions;
            }
            return [
                ...this.adminMinistryUserTypeOptions,
                { id, name: this.getUserTypeDisplayName(id), description: 'نوع حالي — لا يُنشأ من هذه الشاشة.' },
            ];
        },

        isLegacyUserTypeOutsideAdminMinistryList() {
            const raw = this.ruleForm.UserType;
            if (raw === '' || raw === null || raw === undefined) {
                return false;
            }
            const t = Number(raw);
            return t === t && t !== 4 && t !== 40;
        },
    },

    data() {
        const requireBranchValidator = (rule, value, callback) => {
            if (this.requiresBranchSelection() && !value) {
                callback(new Error('الرجاء اختيار الفرع'));
                return;
            }

            callback();
        };

        const requirePermissionsValidator = (rule, value, callback) => {
            if (this.isPermissionBasedRole() && this.normalizePermissions(value).length === 0) {
                callback(new Error('الرجاء اختيار صلاحية واحدة على الأقل لمستخدم الوزارة'));
                return;
            }

            callback();
        };

        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            pageNoT: 1,
            pageSizeT: 10,
            pagesT: 0,
            state: 0,
            Search: '',
            statusFilter: 0,
            userTypeFilter: 0,
            SpecStatistics: { totalUsers: 0, ministryUsers: 0, facilityUsers: 0, activeToday: 0 },

            ScreenTitle: 'حسابات المستخدمين',
            ScreenTitleSingle: 'مستخدم',
            ScreenTitleSingleAl: 'المستخدم',

            Info: [],
            InfoT: [],
            Statistics: [],

            SelectedItem: '',

            ruleForm: {
                Id: '',
                Name: '',
                LoginName: '',
                BranchesId: '',
                Permissions: [],
                Email: '',
                Phone: '',
                Image: '',
                ImageName: '',
                UserType: '',
            },
            /** خيارات «إضافة مستخدم» من شاشة الأدمن: قسم الصيدلة بالوزارة، أو مستخدم وزاري بصلاحيات JSON. */
            adminMinistryUserTypeOptions: [
                { id: 4, name: 'موظف يتبع إدارة الصيدلة', description: 'إدارة طلبات الأدوية من المراكز ومراجعتها صيدلانياً (نطاق وزاري — دون مخزون).' },
                { id: 40, name: 'مستخدم يتبع الوزارة', description: 'حساب وزاري؛ يُحدد وصوله من خلال الصلاحيات المختارة أدناه.' },
            ],
            permissionGroups: [
                {
                    title: 'طلبات الأدوية',
                    options: [
                        { key: 'medicine_orders.view', label: 'عرض طلبات الأدوية' },
                        { key: 'medicine_orders.create', label: 'إنشاء/إرسال طلبات الأدوية' },
                        { key: 'medicine_orders.psychotropic', label: 'طلب أصناف مؤثرات عقلية (حسب تصنيف الصنف)' },
                        { key: 'medicine_orders.narcotic', label: 'طلب أصناف مخدرة (حسب تصنيف الصنف)' },
                    ],
                },
                {
                    title: 'الاستلام والإرجاع والتالف',
                    options: [
                        { key: 'receipt_verification.view', label: 'عرض محاضر الاستلام' },
                        { key: 'receipt_verification.verify', label: 'اعتماد/تأكيد الاستلام' },
                        { key: 'return_orders.view', label: 'عرض أوامر الإرجاع' },
                        { key: 'return_orders.create', label: 'إنشاء أوامر الإرجاع' },
                        { key: 'damage_reports.view', label: 'عرض تقارير التالف' },
                        { key: 'damage_reports.create', label: 'إنشاء تقارير التالف' },
                    ],
                },
                {
                    title: 'الطلبات الخاصة والفائض',
                    options: [
                        { key: 'non_formulary.view', label: 'عرض الطلبات غير النمطية' },
                        { key: 'non_formulary.create', label: 'إنشاء الطلبات غير النمطية' },
                        { key: 'national_formulary_portfolio.view', label: 'عرض نطاق القائمة النمطية للمرفق' },
                        { key: 'national_formulary_portfolio.request', label: 'طلب اعتماد أصناف من القائمة النمطية' },
                        { key: 'surplus_requests.view', label: 'عرض طلبات الفائض' },
                        { key: 'surplus_requests.create', label: 'إنشاء طلبات الفائض' },
                    ],
                },
                {
                    title: 'التدوير والجرد والتنبيهات',
                    options: [
                        { key: 'rotation_transfers.view', label: 'عرض عمليات التدوير' },
                        { key: 'rotation_transfers.receive', label: 'تنفيذ/استلام التدوير' },
                        { key: 'inventory_counts.view', label: 'عرض الجرد' },
                        { key: 'inventory_counts.create', label: 'إنشاء الجرد' },
                        { key: 'inventory_alerts.view', label: 'عرض تنبيهات المخزون' },
                        { key: 'notifications', label: 'استقبال الإشعارات' },
                    ],
                },
            ],
            rules: {
                Name: this.$helper.Required(),
                UserType: this.$helper.Required(),
                Phone: this.$helper.Phone(),
                BranchesId: [{ validator: requireBranchValidator, trigger: 'change' }],
                Permissions: [{ validator: requirePermissionsValidator, trigger: 'change' }],
                //Email: this.$helper.EmailOnly(),
                LoginName: [
                    { required: true, message: 'الرجاء إدخال اسم الدخول', trigger: 'blur' },
                    { required: true, pattern: /^[A-Za-z][A-Za-z0-9]*(\.[A-Za-z][A-Za-z0-9]*)*$/, message: 'الرجاء إدخال اسم الدخول بطريقه صحيحه', trigger: 'blur' }
                ],
            },
        };
    },



    methods: {
        goToAddUser() {
            this.$router.push('/Users/add');
        },

        goBackToUsersList() {
            this.$router.push('/Users');
        },

        permissionCheckboxId(key, suffix) {
            const safe = String(key).replace(/[^a-zA-Z0-9_-]/g, '-');
            return suffix ? `user-perm-${safe}-${suffix}` : `user-perm-${safe}`;
        },

        touchPermissionsField() {
            this.$nextTick(() => {
                if (this.$refs.addRuleForm) {
                    this.$refs.addRuleForm.validateField('Permissions');
                }
                if (this.$refs.editRuleForm) {
                    this.$refs.editRuleForm.validateField('Permissions');
                }
            });
        },

        normalizePermissions(permissions) {
            if (!Array.isArray(permissions)) {
                return [];
            }

            return [...new Set(permissions.filter(x => !!x))];
        },

        parsePermissions(permissions) {
            if (!permissions) {
                return [];
            }

            try {
                const parsed = JSON.parse(permissions);
                return this.normalizePermissions(Array.isArray(parsed) ? parsed : []);
            } catch {
                return [];
            }
        },

        requiresBranchSelection(userType = this.ruleForm.UserType) {
            const normalizedUserType = Number(userType);
            return normalizedUserType === 2 || normalizedUserType === 5 || normalizedUserType === 6;
        },

        isPermissionBasedRole(userType = this.ruleForm.UserType) {
            const t = Number(userType);
            return t === 40;
        },

        handleUserTypeChange() {
            if (!this.requiresBranchSelection()) {
                this.ruleForm.BranchesId = '';
            }

            if (!this.isPermissionBasedRole()) {
                this.ruleForm.Permissions = [];
            }

            this.clearValidationState();
        },

        clearValidationState() {
            ['addRuleForm', 'editRuleForm'].forEach(formRef => {
                if (this.$refs[formRef]) {
                    this.$refs[formRef].clearValidate(['BranchesId', 'Permissions', 'UserType']);
                }
            });
        },

        getUserTypeDisplayName(userType) {
            const t = Number(userType);
            const map = {
                1: 'مدير النظام',
                2: 'مسؤول مرفق صحي',
                3: 'مورد',
                4: 'موظف يتبع إدارة الصيدلة',
                5: 'مستخدم مرفق بصلاحيات مخصصة',
                6: 'مسؤول قسم مرفق صحي',
                40: 'مستخدم يتبع الوزارة',
                41: 'مستخدم (41)',
                42: 'مستخدم (42)',
            };
            return map[t] || 'غير محدد';
        },

        getSelectedUserTypeOption(userType = this.ruleForm.UserType) {
            const id = Number(userType);
            if (!id) {
                return null;
            }
            return this.adminMinistryUserTypeOptions.find(item => item.id === id)
                || { id, name: this.getUserTypeDisplayName(id), description: '' };
        },

        getUserTypeLabel(userType) {
            return this.getUserTypeDisplayName(userType);
        },

        getPermissionLabel(permissionKey) {
            for (const group of this.permissionGroups) {
                const match = group.options.find(item => item.key === permissionKey);
                if (match) {
                    return match.label;
                }
            }

            return permissionKey;
        },

        getPermissionLabels(permissions) {
            return this.parsePermissions(permissions).map(permission => this.getPermissionLabel(permission));
        },

        buildPayload() {
            const userType = Number(this.ruleForm.UserType || 0);
            const payload = {
                ...this.ruleForm,
                UserType: userType,
                BranchesId: this.requiresBranchSelection(userType) ? Number(this.ruleForm.BranchesId) : null,
                Permissions: '',
            };

            if (this.isPermissionBasedRole(userType)) {
                payload.Permissions = JSON.stringify(this.normalizePermissions(this.ruleForm.Permissions));
            }

            return payload;
        },

        fillRuleForm(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.BranchesId = item.branchesId || '';
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.LoginName = item.loginName;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
            this.ruleForm.Permissions = this.parsePermissions(item.permissions);
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetUsers(this.pageNo, this.pageSize, this.Search, this.statusFilter, this.userTypeFilter)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        GetSpecStatistics() {
            this.$http.GetUsersStatistics()
                .then(response => {
                    this.SpecStatistics = (response && response.data) || this.SpecStatistics;
                })
                .catch(() => { /* ignore */ });
        },

        usersSpecCards() {
            const s = this.SpecStatistics || {};
            return [
                this.statCard('إجمالي المستخدمين', s.totalUsers, 'primary', 'ti ti-users'),
                this.statCard('مستخدمي الوزارة', s.ministryUsers, 'info', 'ti ti-building'),
                this.statCard('مستخدمي المرافق', s.facilityUsers, 'success', 'ti ti-hospital'),
                this.statCard('النشطين اليوم', s.activeToday, 'warning', 'ti ti-user-check'),
            ];
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const payload = this.buildPayload();
                    payload.Id = Number(0);
                    this.$blockUI.Start();
                    this.$http.AddUsers(payload)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.ClearForm(this.ruleForm);
                            this.$router.push('/Users');
                            this.GetInfo();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ViewInfo(item) {
            this.fillRuleForm(item);
            this.GetUsersTransactionsInfo();
            this.state = 1;
        },

        GetUsersTransactionsInfo(pageNoT) {
            this.pageNoT = pageNoT;
            if (this.pageNoT === undefined) {
                this.pageNoT = 1;
            }

            this.$blockUI.Start();
                
            this.$http.GetUsersTransactions(this.pageNoT, this.pageSizeT, this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.InfoT = response.data.info;
                    this.pagesT = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pagesT = 0;
                });
        },


        OpentEditDialog(item) {
            this.fillRuleForm(item);
            this.clearValidationState();
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const payload = this.buildPayload();
                    payload.Id = Number(this.ruleForm.Id);
                    this.$blockUI.Start();
                    this.$http.EditUsers(payload)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة العرض  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        ResetPassword(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تهيئة كلمة المرور   ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ResetPasswordUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        //Upload File
        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطاء بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطاء بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },


        Back() {
            this.SelectedItem = '';
            this.state = 0;
        }

    }
}
